(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["memomind-feature-carousel-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__memoMindPresentationCarousels) return;
  window.__memoMindPresentationCarousels = true;
  const controllers = new Map();
  const init = root => {
    root.querySelectorAll('[data-presentation-carousel]').forEach(carousel => {
      if (controllers.has(carousel)) return;
      const track = carousel.querySelector('[data-presentation-track]');
      if (!track) return;
      const cards = [...track.querySelectorAll('[data-presentation-card]')];
      const buttons = [...carousel.querySelectorAll('[data-presentation-direction]')];
      const tabs = [...carousel.querySelectorAll('[data-presentation-tab]')];
      const panels = [...carousel.querySelectorAll('[data-presentation-panel]')];
      const tabScroll = carousel.querySelector('[data-presentation-tab-scroll]');
      const status = carousel.querySelector('[data-presentation-status]');
      if (!cards.length) return;
      const events = new AbortController();
      const { signal } = events;
      carousel.dataset.ready = 'true';
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let active = Math.max(0, cards.findIndex(card => card.classList.contains('is-active'))), frame = 0, destroyed = false, touchStartX = null;
      let inViewport = !('IntersectionObserver' in window), mediaObserver;
      const media = cards.map((card, index) => ({
        index,
        poster: card.querySelector('.mm-presentation__card-poster'),
        video: card.querySelector('[data-presentation-video]'),
        failed: false,
        playing: false
      }));
      const shouldPlay = item => Boolean(item.video && !destroyed && !item.failed && item.index === active && inViewport && !document.hidden && !reduced.matches);
      const showMotion = (item, visible) => {
        if (!item.video) return;
        if (item.poster) item.poster.hidden = visible;
        item.video.hidden = !visible;
      };
      const pauseMedia = item => {
        if (!item.video) return;
        item.playing = false;
        item.video.pause();
      };
      const syncMedia = () => {
        if (destroyed) return;
        media.forEach(item => {
          if (!item.video) return;
          if (!shouldPlay(item)) {
            pauseMedia(item);
            showMotion(item, false);
            return;
          }
          if (item.playing) return;
          if (!item.video.getAttribute('src')) {
            item.video.src = item.video.dataset.src;
            item.video.load();
          }
          item.playing = true;
          Promise.resolve(item.video.play()).then(() => {
            if (!shouldPlay(item)) {
              pauseMedia(item);
              showMotion(item, false);
            }
          }).catch(() => {
            if (destroyed) return;
            item.playing = false;
            showMotion(item, false);
          });
        });
      };
      media.forEach(item => {
        if (!item.video) return;
        item.video.addEventListener('playing', () => {
          if (shouldPlay(item)) showMotion(item, true);
          else {
            pauseMedia(item);
            showMotion(item, false);
          }
        }, {signal});
        item.video.addEventListener('error', () => {
          if (destroyed) return;
          item.failed = true;
          pauseMedia(item);
          showMotion(item, false);
        }, {signal});
      });
      reduced.addEventListener?.('change', syncMedia, {signal});
      document.addEventListener('visibilitychange', syncMedia, {signal});
      if (!inViewport) {
        mediaObserver = new IntersectionObserver(entries => {
          if (destroyed) return;
          inViewport = entries.some(entry => entry.isIntersecting);
          syncMedia();
        });
        mediaObserver.observe(track);
      }
      const wrap = index => (index % cards.length + cards.length) % cards.length;
      const revealTab = smooth => {
        if (!tabScroll || !tabs[active]) return;
        const max = Math.max(0, tabScroll.scrollWidth - tabScroll.clientWidth);
        const left = Math.max(0, Math.min(max, tabs[active].offsetLeft - (tabScroll.clientWidth - tabs[active].offsetWidth) / 2));
        tabScroll.scrollTo({left, behavior:smooth && !reduced.matches ? 'smooth' : 'auto'});
      };
      const select = (index, {smooth = true, focusTab = false, announce = true} = {}) => {
        if (destroyed) return;
        active = wrap(index);
        cards.forEach((card, i) => {
          const selected = i === active;
          card.classList.toggle('is-active', selected);
          card.hidden = !selected;
          card.setAttribute('aria-hidden', String(!selected));
        });
        tabs.forEach((tab, i) => {
          const selected = i === active;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel, i) => { panel.hidden = i !== active; });
        if (focusTab) tabs[active]?.focus({preventScroll:true});
        revealTab(smooth);
        if (announce && status) status.textContent = `${active + 1} / ${cards.length}: ${tabs[active]?.textContent.trim() || ''}`;
        syncMedia();
      };
      const handleDirectionalKey = event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1);
        select(index, {focusTab: event.target.matches?.('[data-presentation-tab]')});
      };
      buttons.forEach(button => button.addEventListener('click', () => select(active + Number(button.dataset.presentationDirection)), {signal}));
      tabs.forEach(tab => {
        tab.addEventListener('click', () => select(Number(tab.dataset.presentationTab)), {signal});
        tab.addEventListener('keydown', handleDirectionalKey, {signal});
      });
      track.addEventListener('keydown', handleDirectionalKey, {signal});
      track.addEventListener('touchstart', event => { touchStartX = event.touches[0]?.clientX ?? null; }, {passive:true, signal});
      track.addEventListener('touchend', event => {
        if (touchStartX === null) return;
        const delta = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
        touchStartX = null;
        if (Math.abs(delta) >= 40) select(active + (delta < 0 ? 1 : -1));
      }, {passive:true, signal});
      window.addEventListener('resize', () => revealTab(false), {signal});
      document.addEventListener('shopify:block:select', event => {
        const index = cards.findIndex(card => card.dataset.blockId === event.detail?.blockId);
        if (index >= 0) select(index, {smooth:false});
      }, {signal});
      controllers.set(carousel, {
        destroy() {
          if (destroyed) return;
          destroyed = true;
          events.abort();
          mediaObserver?.disconnect();
          media.forEach(item => {
            pauseMedia(item);
            showMotion(item, false);
            if (item.video) {
              item.video.removeAttribute('src');
              item.video.load();
            }
          });
          cancelAnimationFrame(frame);
          frame = 0;
          delete carousel.dataset.ready;
          controllers.delete(carousel);
        }
      });
      frame = requestAnimationFrame(() => { frame = 0; select(active, {smooth:false, announce:false}); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true}); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((controller, carousel) => {
      if (event.target.contains(carousel)) controller.destroy();
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["memomind-usecase-shared"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('memomind-usecase-tail')) {
    class MemoMindUsecaseTail extends HTMLElement {
      connectedCallback() {
        this.onClick = this.onClick.bind(this);
        this.onGuideWheel = this.onGuideWheel.bind(this);
        this.onGuidePointerDown = this.onGuidePointerDown.bind(this);
        this.onGuidePointerMove = this.onGuidePointerMove.bind(this);
        this.onGuidePointerUp = this.onGuidePointerUp.bind(this);
        this.onGuidePointerCancel = this.onGuidePointerCancel.bind(this);
        this.onGuideClick = this.onGuideClick.bind(this);
        this.onGuideNativeDrag = this.onGuideNativeDrag.bind(this);
        this.carouselStates = new Map();
        this.guideProgressStates = new Map();
        this.guideDragStates = new Map();
        this.guideSuppressedClickTrack = null;
        this.guideClickTimer = 0;
        this.faqTimers = new Map();
        this.guideTracks = Array.from(this.querySelectorAll('[data-mm-guide-track]'));
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.orbitReveal = null;
        this.addEventListener('click', this.onClick);
        this.guideTracks.forEach((track) => {
          track.addEventListener('wheel', this.onGuideWheel, { passive: false });
          track.addEventListener('pointerdown', this.onGuidePointerDown);
          track.addEventListener('pointermove', this.onGuidePointerMove, { passive: false });
          track.addEventListener('pointerup', this.onGuidePointerUp);
          track.addEventListener('pointercancel', this.onGuidePointerCancel);
          track.addEventListener('click', this.onGuideClick, true);
          track.addEventListener('dragstart', this.onGuideNativeDrag);
          this.mountGuideProgress(track);
        });
        this.querySelectorAll('[data-mm-carousel-finite]').forEach((track) => this.mountCarousel(track));
        this.querySelectorAll('.mm-usecase-tail__faq-item').forEach((item) => {
          item.classList.toggle('is-expanded', item.open);
        });
        this.mountOrbitReveal();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.guideTracks.forEach((track) => {
          track.removeEventListener('wheel', this.onGuideWheel);
          track.removeEventListener('pointerdown', this.onGuidePointerDown);
          track.removeEventListener('pointermove', this.onGuidePointerMove);
          track.removeEventListener('pointerup', this.onGuidePointerUp);
          track.removeEventListener('pointercancel', this.onGuidePointerCancel);
          track.removeEventListener('click', this.onGuideClick, true);
          track.removeEventListener('dragstart', this.onGuideNativeDrag);
          track.classList.remove('is-dragging');
        });
        this.guideProgressStates.forEach((state) => this.unmountGuideProgress(state));
        this.guideProgressStates.clear();
        this.guideDragStates.clear();
        this.guideSuppressedClickTrack = null;
        window.clearTimeout(this.guideClickTimer);
        this.carouselStates.forEach((state) => this.unmountCarousel(state));
        this.carouselStates.clear();
        this.faqTimers.forEach((timer) => window.clearTimeout(timer));
        this.faqTimers.clear();
        this.unmountOrbitReveal();
      }

      mountOrbitReveal() {
        const orbit = this.querySelector('[data-mm-orbit-reveal]');
        const gsap = window.gsap;
        const ScrollTrigger = window.ScrollTrigger;
        if (!orbit || !gsap || !ScrollTrigger || this.reducedMotionQuery.matches) return;

        const items = Array.from(orbit.querySelectorAll('[data-mm-orbit-item]'));
        const portraits = items.map((item) => item.querySelector('[data-mm-orbit-image]')).filter(Boolean);
        const labels = items.map((item) => item.querySelector('h3')).filter(Boolean);
        if (!portraits.length) return;

        gsap.set(portraits, {
          autoAlpha: 0,
          scale: 0.35,
          y: 28,
          transformOrigin: '50% 70%',
          willChange: 'transform,opacity'
        });
        gsap.set(labels, {
          autoAlpha: 0,
          y: 8,
          willChange: 'transform,opacity'
        });

        const animatedNodes = [...portraits, ...labels];
        const clearAnimatedStyles = () => {
          gsap.set(animatedNodes, { clearProps: 'opacity,visibility,transform,willChange' });
        };
        const timeline = gsap.timeline({
          paused: true,
          onComplete: clearAnimatedStyles
        });

        items.forEach((item, index) => {
          const portrait = item.querySelector('[data-mm-orbit-image]');
          const label = item.querySelector('h3');
          const itemStart = index * 0.14;
          if (portrait) {
            timeline.to(portrait, {
              autoAlpha: 1,
              scale: 1,
              y: 0,
              duration: 0.58,
              ease: 'back.out(1.8)'
            }, itemStart);
          }
          if (label) {
            timeline.to(label, {
              autoAlpha: 1,
              y: 0,
              duration: 0.28,
              ease: 'power2.out'
            }, itemStart + 0.18);
          }
        });

        const state = {
          timeline,
          trigger: null,
          animatedNodes,
          played: false
        };
        const reveal = () => {
          if (state.played) return;
          state.played = true;
          if (this.reducedMotionQuery.matches) {
            timeline.kill();
            clearAnimatedStyles();
            return;
          }
          timeline.play(0);
        };

        state.trigger = ScrollTrigger.create({
          trigger: orbit,
          start: 'top 78%',
          onEnter: reveal,
          onEnterBack: reveal,
          once: true
        });
        this.orbitReveal = state;
      }

      unmountOrbitReveal() {
        if (!this.orbitReveal) return;
        this.orbitReveal.trigger?.kill();
        this.orbitReveal.timeline?.kill();
        if (window.gsap && this.orbitReveal.animatedNodes.length) {
          window.gsap.set(this.orbitReveal.animatedNodes, {
            clearProps: 'opacity,visibility,transform,willChange'
          });
        }
        this.orbitReveal = null;
      }

      onGuideWheel(event) {
        if (Math.abs(event.deltaX) >= Math.abs(event.deltaY) || event.deltaY === 0) return;
        const track = event.currentTarget;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const nextLeft = Math.max(0, Math.min(maxScroll, track.scrollLeft + event.deltaY));
        if (Math.abs(nextLeft - track.scrollLeft) < 1) return;
        event.preventDefault();
        track.scrollLeft = nextLeft;
      }

      onGuidePointerDown(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        const track = event.currentTarget;
        if (track.scrollWidth <= track.clientWidth + 1) return;
        this.guideDragStates.set(track, {
          pointerId: event.pointerId,
          startX: event.clientX,
          startScrollLeft: track.scrollLeft,
          moved: false
        });
        track.classList.add('is-dragging');
        if (track.setPointerCapture) track.setPointerCapture(event.pointerId);
      }

      onGuidePointerMove(event) {
        const track = event.currentTarget;
        const state = this.guideDragStates.get(track);
        if (!state || state.pointerId !== event.pointerId) return;
        const distance = event.clientX - state.startX;
        if (!state.moved && Math.abs(distance) < 5) return;
        state.moved = true;
        event.preventDefault();
        track.scrollLeft = state.startScrollLeft - distance;
      }

      finishGuidePointer(event, suppressClick) {
        const track = event.currentTarget;
        const state = this.guideDragStates.get(track);
        if (!state || state.pointerId !== event.pointerId) return;
        if (suppressClick && state.moved) {
          this.guideSuppressedClickTrack = track;
          window.clearTimeout(this.guideClickTimer);
          this.guideClickTimer = window.setTimeout(() => {
            this.guideSuppressedClickTrack = null;
            this.guideClickTimer = 0;
          }, 0);
        }
        if (track.hasPointerCapture && track.hasPointerCapture(event.pointerId)) {
          track.releasePointerCapture(event.pointerId);
        }
        track.classList.remove('is-dragging');
        this.guideDragStates.delete(track);
      }

      onGuidePointerUp(event) {
        this.finishGuidePointer(event, true);
      }

      onGuidePointerCancel(event) {
        this.finishGuidePointer(event, false);
      }

      onGuideClick(event) {
        if (this.guideSuppressedClickTrack !== event.currentTarget) return;
        event.preventDefault();
        event.stopPropagation();
        this.guideSuppressedClickTrack = null;
        window.clearTimeout(this.guideClickTimer);
        this.guideClickTimer = 0;
      }

      onGuideNativeDrag(event) {
        event.preventDefault();
      }

      updateGuideProgress(state) {
        const firstItem = state.items[0];
        if (!firstItem) return;
        const styles = window.getComputedStyle(state.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const step = firstItem.getBoundingClientRect().width + gap;
        if (!step) return;
        const currentIndex = Math.max(0, Math.min(
          state.items.length - 1,
          Math.round(state.track.scrollLeft / step)
        ));
        state.progress.querySelectorAll('[data-mm-guide-progress-index]').forEach((segment) => {
          segment.classList.toggle(
            'is-active',
            Number(segment.dataset.mmGuideProgressIndex) === currentIndex
          );
        });
      }

      handleGuideProgressScroll(state) {
        if (state.scrollFrame) return;
        state.scrollFrame = window.requestAnimationFrame(() => {
          state.scrollFrame = 0;
          this.updateGuideProgress(state);
        });
      }

      mountGuideProgress(track) {
        const items = Array.from(track.querySelectorAll(':scope > [data-mm-guide-item]'));
        const progress = Array.from(this.querySelectorAll('[data-mm-guide-progress]')).find(
          (item) => item.dataset.mmGuideProgress === track.id
        );
        if (!items.length || !progress) return;
        const state = {
          track,
          items,
          progress,
          scrollFrame: 0,
          resizeObserver: null,
          onScroll: null
        };
        state.onScroll = () => this.handleGuideProgressScroll(state);
        track.addEventListener('scroll', state.onScroll, { passive: true });
        if ('ResizeObserver' in window) {
          state.resizeObserver = new ResizeObserver(() => this.updateGuideProgress(state));
          state.resizeObserver.observe(track);
        }
        this.guideProgressStates.set(track, state);
        this.updateGuideProgress(state);
      }

      unmountGuideProgress(state) {
        state.track.removeEventListener('scroll', state.onScroll);
        if (state.resizeObserver) state.resizeObserver.disconnect();
        if (state.scrollFrame) window.cancelAnimationFrame(state.scrollFrame);
      }

      getCarouselMetrics(state) {
        const firstCard = state.originals[0];
        const styles = window.getComputedStyle(state.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : state.track.clientWidth;
        return { gap, step: cardWidth + gap };
      }

      getCarouselPageSize(state) {
        const isPhone = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
        return isPhone ? 1 : state.pageSize;
      }

      updateCarouselProgress(state) {
        if (!state.progress) return;
        state.progress.querySelectorAll('[data-mm-carousel-progress-index]').forEach((segment) => {
          const progressIndex = Number(segment.dataset.mmCarouselProgressIndex);
          segment.classList.toggle('is-active', progressIndex === state.currentIndex);
        });
      }

      updateCarouselState(state) {
        const metrics = this.getCarouselMetrics(state);
        const pageSize = this.getCarouselPageSize(state);
        const maxScroll = Math.max(0, state.track.scrollWidth - state.track.clientWidth);
        const atStart = state.track.scrollLeft <= 1;
        const atEnd = state.track.scrollLeft >= maxScroll - 1;
        if (metrics.step && state.originals.length) {
          const firstVisibleIndex = Math.round(state.track.scrollLeft / metrics.step);
          state.pageCount = Math.ceil(state.originals.length / pageSize);
          state.currentIndex = Math.max(0, Math.min(
            state.pageCount - 1,
            Math.floor(firstVisibleIndex / pageSize)
          ));
        }
        state.previousButton.disabled = atStart;
        state.previousButton.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        state.nextButton.disabled = atEnd || state.originals.length < 2;
        state.nextButton.setAttribute('aria-disabled', state.nextButton.disabled ? 'true' : 'false');
        this.updateCarouselProgress(state);
      }

      handleCarouselScroll(state) {
        if (state.scrollFrame) return;
        state.scrollFrame = window.requestAnimationFrame(() => {
          state.scrollFrame = 0;
          this.updateCarouselState(state);
        });
      }

      mountCarousel(track) {
        const originals = Array.from(track.querySelectorAll(':scope > [data-mm-carousel-item]'));
        const previousButton = this.querySelector(`[data-mm-carousel-target="${track.id}"][data-mm-carousel-direction="-1"]`);
        const nextButton = this.querySelector(`[data-mm-carousel-target="${track.id}"][data-mm-carousel-direction="1"]`);
        if (!originals.length || !previousButton || !nextButton) return;
        const progress = Array.from(this.querySelectorAll('[data-mm-carousel-progress]')).find(
          (item) => item.dataset.mmCarouselProgress === track.id
        );
        const pageSize = Math.max(1, Number(track.dataset.mmCarouselPageSize) || 1);
        const state = {
          track,
          originals,
          progress,
          previousButton,
          nextButton,
          pageSize,
          pageCount: Math.ceil(originals.length / pageSize),
          currentIndex: 0,
          scrollFrame: 0,
          resizeTimer: 0,
          resizeObserver: null,
          onScroll: null
        };
        state.onScroll = () => this.handleCarouselScroll(state);
        track.addEventListener('scroll', state.onScroll, { passive: true });
        if ('ResizeObserver' in window) {
          state.resizeObserver = new ResizeObserver(() => {
            window.clearTimeout(state.resizeTimer);
            state.resizeTimer = window.setTimeout(() => this.updateCarouselState(state), 120);
          });
          state.resizeObserver.observe(track);
        }
        this.carouselStates.set(track, state);
        this.updateCarouselState(state);
      }

      unmountCarousel(state) {
        state.track.removeEventListener('scroll', state.onScroll);
        if (state.resizeObserver) state.resizeObserver.disconnect();
        if (state.scrollFrame) window.cancelAnimationFrame(state.scrollFrame);
        window.clearTimeout(state.resizeTimer);
      }

      moveCarousel(state, direction) {
        const metrics = this.getCarouselMetrics(state);
        if (!metrics.step) return;
        const pageSize = this.getCarouselPageSize(state);
        const maxScroll = Math.max(0, state.track.scrollWidth - state.track.clientWidth);
        const targetLeft = Math.max(0, Math.min(maxScroll, state.track.scrollLeft + metrics.step * pageSize * direction));
        const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        state.track.scrollTo({
          left: targetLeft,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }

      collapseFaq(item) {
        const pendingTimer = this.faqTimers.get(item);
        if (pendingTimer) {
          window.clearTimeout(pendingTimer);
          this.faqTimers.delete(item);
        }

        if (!item.classList.contains('is-expanded')) return;

        item.classList.remove('is-expanded');
        if (this.reducedMotionQuery.matches) {
          item.open = false;
          return;
        }

        const timer = window.setTimeout(() => {
          if (!item.classList.contains('is-expanded')) item.open = false;
          this.faqTimers.delete(item);
        }, 380);
        this.faqTimers.set(item, timer);
      }

      toggleFaq(item) {
        const pendingTimer = this.faqTimers.get(item);
        if (pendingTimer) {
          window.clearTimeout(pendingTimer);
          this.faqTimers.delete(item);
        }

        if (item.classList.contains('is-expanded')) {
          this.collapseFaq(item);
          return;
        }

        if (this.dataset.scenario === 'presentations') {
          this.querySelectorAll('.mm-usecase-tail__faq-item.is-expanded').forEach((expandedItem) => {
            if (expandedItem !== item) this.collapseFaq(expandedItem);
          });
        }

        item.open = true;
        if (!this.reducedMotionQuery.matches) {
          const answerShell = item.querySelector('[data-mm-faq-answer]');
          if (answerShell) answerShell.getBoundingClientRect();
        }
        item.classList.add('is-expanded');
      }

      onClick(event) {
        const faqSummary = event.target.closest('.mm-usecase-tail__faq-item > summary');
        if (faqSummary && this.contains(faqSummary)) {
          event.preventDefault();
          this.toggleFaq(faqSummary.parentElement);
          return;
        }

        const tryOnButton = event.target.closest('[data-mm-open-vto]');
        if (tryOnButton) {
          if (typeof window.openArTryOn === 'function') {
            window.openArTryOn(tryOnButton.dataset.vsku || undefined);
          }
          return;
        }

        const carouselButton = event.target.closest('[data-mm-carousel-target]');
        if (!carouselButton) return;
        const targetId = carouselButton.dataset.mmCarouselTarget;
        const track = Array.from(this.querySelectorAll('[data-mm-carousel]')).find((item) => item.id === targetId);
        if (!track) return;
        const direction = Number(carouselButton.dataset.mmCarouselDirection || 1);
        const carouselState = this.carouselStates.get(track);
        if (carouselState) {
          this.moveCarousel(carouselState, direction);
          return;
        }
        const firstCard = track.firstElementChild;
        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const step = (firstCard ? firstCard.getBoundingClientRect().width : track.clientWidth) + gap;
        const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: step * direction, behavior: reducedMotion ? 'auto' : 'smooth' });
      }
    }

    customElements.define('memomind-usecase-tail', MemoMindUsecaseTail);
  }
  } catch(e) { console.error(e); }
})();

})();
